// PWA Utilities
// Runtime detection - use /api for production, localhost for dev
const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) ? 'http://localhost:8001/api' : '/api';

export const updatePWAManifest = async (brokerId) => {
  try {
    // Update manifest link to point to backend with broker_id
    const manifestLink = document.querySelector('link[rel="manifest"]');
    if (manifestLink) {
      manifestLink.href = `${API}/pwa/manifest?broker_id=${brokerId}`;
      console.log('✅ PWA Manifest updated for broker:', brokerId);
    }
    
    // Fetch manifest data for theme updates
    const response = await fetch(`${API}/pwa/manifest?broker_id=${brokerId}`);
    const manifestData = await response.json();
    
    // Update theme color
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta && manifestData.theme_color) {
      themeColorMeta.content = manifestData.theme_color;
    }
    
    // Update title
    if (manifestData.name) {
      document.title = manifestData.name;
    }
    
    // Update apple touch icon
    let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (manifestData.icons && manifestData.icons.length > 0) {
      if (!appleTouchIcon) {
        appleTouchIcon = document.createElement('link');
        appleTouchIcon.rel = 'apple-touch-icon';
        document.head.appendChild(appleTouchIcon);
      }
      appleTouchIcon.href = manifestData.icons[0].src;
    }
    
    // Update favicon
    let favicon = document.querySelector('link[rel="icon"]');
    if (manifestData.icons && manifestData.icons.length > 0) {
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }
      favicon.href = manifestData.icons[0].src;
    }
    
    console.log('✅ PWA manifest updated for broker:', brokerId);
    return true;
  } catch (error) {
    console.error('❌ Failed to update PWA manifest:', error);
    return false;
  }
};

export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(registration => {
          console.log('✅ Service Worker registered:', registration);
        })
        .catch(error => {
          console.error('❌ Service Worker registration failed:', error);
        });
    });
  }
};
